import { Inject } from "typescript-ioc";
import { UiComponent } from "Ui/Scripts/UiComponent";
import { UiComponentFactory } from "Ui/Scripts/UiComponentFactory";
import { EventBinder } from "Events/Scripts/EventBinder";
import { LoggerFactory } from "Logging/Scripts/LoggerFactory";
import { Button } from "Ui/Scripts/Button";
import { RadioButton } from "Ui/Scripts/RadioButton";
import { Utils } from "Helpers/Scripts/Utils";

export class EndConsumerSelectorRowComponentView extends UiComponent {
    public customerId: number;
    public customerName: string;
    public addressId: number;

    public editButton: Button;
    public deleteButton: Button;
    public radioButton: RadioButton;

    private readonly DATA_CUSTOMER_ID: string = "customer-id";
    private readonly DATA_CUSTOMER_NAME: string = "customer-name";
    private readonly DATA_ADDRESS_ID: string = "address-id";

    private readonly EDIT_BUTTON_SELECTOR: string = ".js-edit-end-consumer";
    private readonly DELETE_BUTTON_SELECTOR: string = ".js-delete-end-consumer";

    constructor(
        @Inject componentFactory: UiComponentFactory,
        @Inject binder: EventBinder,
        @Inject loggerFactory: LoggerFactory
    ) {
        super(componentFactory, binder, loggerFactory);
    }

    protected init(): void {
        this.customerId = this.getData(this.DATA_CUSTOMER_ID);
        this.customerName = this.getData(this.DATA_CUSTOMER_NAME);
        this.addressId = this.getData(this.DATA_ADDRESS_ID);
        if (Utils.find(this._context, this.EDIT_BUTTON_SELECTOR).length > 0) {
            this.editButton = this.createComponent(Button, this.EDIT_BUTTON_SELECTOR);
        }
        if (Utils.find(this._context, this.DELETE_BUTTON_SELECTOR).length > 0) {
            this.deleteButton = this.createComponent(Button, this.DELETE_BUTTON_SELECTOR);
        }
        this.radioButton = this.createComponent(RadioButton, "input[type=radio]");
    }
}
